import { Brand } from 'mmds';
import { formatReviewDate } from '../utilities';
import cn from 'clsx';
import s from './product-assistance.module.css';

const getFitLabel = (value) => {
    const fitMapping = [
        { label: 'Runs small', values: [1, 2] },
        { label: 'True to size', values: [3] },
        { label: 'Runs large', values: [4, 5] },
    ];

    const roundedValue = Math.round(value);
    const fitCategory = fitMapping.find((category) =>
        category.values.includes(roundedValue)
    );
    return fitCategory ? fitCategory.label : '';
};

const ProductReviews = ({ review }) => {
    // console.log('review', review);
    return (
        <div className={cn(s.stack, s.reviews)}>
            <div className={s.authorDate}>
                <h3 className="mmds-copy-three">{review.author}</h3>
                {review.product_name && (
                    <h3 className="mmds-copy-three">{review.product_name}</h3>
                )}
                <time className="mmds-copy-three">
                    {formatReviewDate(review.date_created)}
                </time>
            </div>
            <p className={cn('mmds-copy-one')}>{review.review}</p>

            {/* Replies, if any */}
            {review.replies && review.replies.length > 0 && (
                <div className={s.repliesContainer}>
                    {review.replies.map((reply) => (
                        <div key={reply.id} className={cn(s.reply)}>
                            <Brand className={s.brand} />
                            <div className={s.stack} data-flow-space="medium">
                                <h3 className="mmds-copy-three">Reply:</h3>
                                <p className="mmds-copy-one">
                                    {reply.comments}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className={cn(s.grid, 'mmds-copy-three')}>
                {review?.attributes?.length >= 1
                    ? review?.attributes?.map((attribute, index) => {
                          return attribute && attribute.value ? (
                              <div key={index} className={s.reviewRating}>
                                  <dl className={s.ratingLabel}>
                                      {attribute.label}.{' '}
                                  </dl>
                                  <dd>
                                      {attribute.label === 'Fit'
                                          ? getFitLabel(attribute.value)
                                          : `${attribute.value}/5`}
                                  </dd>
                              </div>
                          ) : null;
                      })
                    : ''}
                {!review?.attributes &&
                    ['comfort', 'performance', 'fit'].map((ratingKey) => {
                        const rating = review[ratingKey];
                        return rating && rating.value ? (
                            <div key={ratingKey} className={s.reviewRating}>
                                <dl className={s.ratingLabel}>
                                    {rating.label}.{' '}
                                </dl>
                                <dd>
                                    {ratingKey === 'fit'
                                        ? getFitLabel(rating.value)
                                        : `${rating.value}/5`}
                                </dd>
                            </div>
                        ) : null;
                    })}
            </div>
            <hr className="divider" data-color="black" />
        </div>
    );
};

export default ProductReviews;
